import {InputTextV2} from '@prtimes-basis/input';
import {useWatch} from 'react-hook-form';
import {FormField, useFormField} from '../../../form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {PasswordValidation} from '@/components/utils/password-validation';

export function PasswordField() {
  const {control} = useFormField({hasDescription: true});
  const {password} = useWatch({control, name: 'contactPersonInfo'});
  return (
    <FormField.Root name='contactPersonInfo.password'>
      <Body />

      <FormField.Error />

      <PasswordValidation password={password} />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({hasDescription: true});

  return (
    <InputTextV2
      required
      type='password'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
